import { GREETINGS_SHOW, GREETINGS_CLOSE } from './types'

export function GreetingsShow(stopAction: boolean) {
  return {
    type: GREETINGS_SHOW,
    payload: stopAction,
  }
}

export function GreetingsClose(stopAction: boolean) {
  return {
    type: GREETINGS_CLOSE,
    payload: stopAction,
  }
}
